module.exports = __webpack_public_path__ + "static/media/team3.d3434905.png";